import { REFERENCE_ASSET_BASE_URL } from "../../configs";

/**
 * Resolves an asset path to a full URL when reference asset base is configured.
 * Use for API-returned paths like /assets/img/restaurant-sliders/... or /assets/img/items/...
 * so they load from the reference server (e.g. https://app.dittomart.in) instead of base.
 *
 * @param {string} path - Asset path (e.g. "/assets/img/restaurant-sliders/1766127579_6944f7db40026.jpg")
 * @returns {string} - Same path, or base + path when referenceAssetBaseUrl is set
 */
export function getAssetUrl(path) {
	if (path == null || typeof path !== "string") return path;
	if (path.startsWith("http://") || path.startsWith("https://")) return path;

	const base = typeof localStorage !== "undefined"
		? (localStorage.getItem("referenceAssetBaseUrl") || REFERENCE_ASSET_BASE_URL)
		: REFERENCE_ASSET_BASE_URL;

	if (!base || base.trim() === "") return path;

	const baseTrimmed = base.replace(/\/$/, "");
	const pathNorm = path.startsWith("/") ? path : "/" + path;
	return baseTrimmed + pathNorm;
}
